// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface LockUnlockIconSignature {
  Element: SVGSVGElement;
}

export const LockUnlockIcon: TOC<LockUnlockIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 11H9V7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7V8H17V7C17 4.243 14.757 2 12 2C9.243 2 7 4.243 7 7V11C5.896 11 5 11.896 5 13V20C5 21.103 5.896 22 7 22H17C18.104 22 19 21.103 19 20V13C19 11.896 18.104 11 17 11ZM7 20V13H17L17.002 20H7ZM13.0607 17.5606C13.6465 16.9748 13.6465 16.0251 13.0607 15.4393C12.4749 14.8535 11.5252 14.8535 10.9394 15.4393C10.3536 16.0251 10.3536 16.9748 10.9394 17.5606C11.5252 18.1464 12.4749 18.1464 13.0607 17.5606Z"/>
</svg>
</template>;